/* global youbora */
youbora.registerAdapter('SpotXAdapter', require('./adapter'))

module.exports = youbora
